export interface IPagingResultShopperStaffDiscountItem {
    Items: IShopperStaffDiscountItem[];
    Total: number;
}

export interface IShopperStaffDiscountItem {
    ID: number;
    Email: string;
    CreateDateUTC: Date;
    /// <summary>0 = None, 1 = Active, 2 = ExpiredSoon, 3 = Expired</summary>
    Status: ShopperStaffDiscountItemStatus;
    IsArchived: boolean;
    FullName: string;
    DiscountExpirationDate: Date;
}

export type ShopperStaffDiscountItemStatus = 0 | 1 | 2 | 3;
export const ShopperStaffDiscountItemStatusEnum = {
    None: 0 as ShopperStaffDiscountItemStatus,
    Active: 1 as ShopperStaffDiscountItemStatus,
    ExpiredSoon: 2 as ShopperStaffDiscountItemStatus,
    Expired: 3 as ShopperStaffDiscountItemStatus,
};



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/IPagingResultShopperStaffDiscountItem.ts